import { ExternalLink, Newspaper, Phone } from "lucide-react";

const formatPrice = (value) =>
  value ? new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(value) : "—";

export const PigeListings = ({ listings }) => (
  <section className="mandate-pige-section" data-testid="mandate-pige-section">
    <div className="mandate-section-heading">
      <div>
        <p className="mandate-overline">Node 4 · Pige licenciée</p>
        <h2>Annonces particuliers · Vaucluse</h2>
      </div>
    </div>
    {listings.length === 0 ? (
      <div className="mandate-empty" data-testid="pige-empty">
        <Newspaper size={22} />
        <p>Aucune annonce collectée pour le moment.</p>
        <span>La pige Pige Online tourne toutes les 2 heures dès que l’abonnement API est actif.</span>
      </div>
    ) : (
      <div className="mandate-pige-list" data-testid="pige-listing-list">
        {listings.map((listing) => (
          <article key={listing.listing_id} data-testid={`pige-listing-${listing.listing_id}`}>
            <div>
              <strong>{listing.titre || `${listing.property_type} · ${listing.ville}`}</strong>
              <small>
                {listing.published_at} · {listing.ville} ({listing.cp}) · {listing.transaction}
                {listing.surface > 0 && ` · ${listing.surface} m²`}
                {listing.pieces > 0 && ` · ${listing.pieces} p.`}
                {listing.price_changes > 0 && ` · ${listing.price_changes} baisse(s) de prix`}
              </small>
              <span className="mandate-pige-sources">
                {(listing.sources || []).slice(0, 3).map((entry) => (
                  <a key={entry.url} href={entry.url} target="_blank" rel="noopener noreferrer">
                    {entry.source} <ExternalLink size={11} />
                  </a>
                ))}
              </span>
            </div>
            <div className="mandate-pige-side">
              <b>{formatPrice(listing.prix)}</b>
              {listing.phone && (
                <a href={`tel:${listing.phone}`} data-testid={`pige-phone-${listing.listing_id}`}>
                  <Phone size={12} /> {listing.phone}
                </a>
              )}
              {listing.bloctel === "INSCRIT" && <em>Bloctel : ne pas démarcher</em>}
              {listing.phone && !listing.bloctel && (
                <em className="mandate-bloctel-unknown" data-testid={`bloctel-unknown-${listing.listing_id}`}>
                  Attention : statut Bloctel non communiqué
                </em>
              )}
            </div>
          </article>
        ))}
      </div>
    )}
  </section>
);
